import { defineMessages } from 'react-intl';

const messages = defineMessages({
  sectionTitle: { id: 'Section title', defaultMessage: 'Section title' },
  align: {
    id: 'Align',
    defaultMessage: 'Align',
  },
  left: {
    id: 'Left',
    defaultMessage: 'Left',
  },
  right: {
    id: 'Right',
    defaultMessage: 'Right',
  },
  center: {
    id: 'Center',
    defaultMessage: 'Center',
  },
  title: { id: 'Title', defaultMessage: 'Title' },
  titleLink: { id: 'titleLink', defaultMessage: 'Link URL' },
  textFiedDescription: {
    id: 'textFiedDescription',
    defaultMessage: 'Enter the text that will be displayed in the block.',
  },

  titleLinkDescription: {
    id: 'titleLinkDescription',
    defaultMessage: 'If filled in, the title will be a link.',
  },
});

export const Schema = ({ intl }) => {
  return {
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.sectionTitle),
        fields: ['title', 'titleLink', 'align'],
      },
    ],
    properties: {
      title: {
        title: intl.formatMessage(messages.title),
        description: intl.formatMessage(messages.textFiedDescription),
      },
      titleLink: {
        title: intl.formatMessage(messages.titleLink),
        description: intl.formatMessage(messages.titleLinkDescription),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: ['Title', 'Description'],
        allowExternals: true,
      },
      align: {
        title: intl.formatMessage(messages.align),
        widget: 'text_align_widget',
        default: 'center',
        actions: ['left', 'center', 'right'],
      },
    },
    required: ['title'],
  };
};
